import type { FunctionComponent } from 'react';
import Icon from './Icon';
import type { IconSize } from './icon-constants';
import { icons } from './icons';

type GreenCheckProps = {
  size?: IconSize;
};

const GreenCheck: FunctionComponent<GreenCheckProps> = ({ size }) => (
  <span className="fossa-green-check">
    <Icon icon={icons.check} size={size} />
  </span>
);

export default GreenCheck;
